import { Controller, useFormContext } from "react-hook-form";
import type { EmojiPickerV3Props } from "../../EmojiPickerV3";
import { EmojiPickerV3 } from "../../EmojiPickerV3";

export interface FormEmojiPickerProps extends EmojiPickerV3Props {
  name: string;
}

export const FormEmojiPicker = ({
  name,
  ...passThroughProps
}: FormEmojiPickerProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value },
      }: {
        field: {
          onChange: (value: any) => void;
          value: any;
        };
      }) => (
        <EmojiPickerV3
          {...passThroughProps}
          value={value}
          onEmojiSelect={onChange}
        />
      )}
    />
  );
};

FormEmojiPicker.displayName = "Form.EmojiPickerV3";
